module.exports = __webpack_public_path__ + "static/media/Logo_EN.8c5b9d96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_EN.svg
// module id = 153
// module chunks = 0